import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import { actions as metaActions } from '@ui/store/meta';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { push } from 'connected-react-router';

export const createEntity: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { regionApi },
) =>
  action$.pipe(
    ofType(actions.CREATE_ENTITY_ACTIONS.REQUESTED),
    switchMap(({ payload: { entity } }) =>
      regionApi.createEntity(entity).pipe(
        switchMap(() =>
          of(
            actions.createEntitySucceeded(),
            push('/countries'),
            metaActions.metaRequested(),
          ),
        ),
        catchError(error => of(actions.createEntityFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Stores/services/epics/createEntity.ts